export default "__VITE_ASSET__DlPz7p9o__"